import React from "react"
import { IGigPoolDocument } from "../../models/documents/GigPoolDocument"
import { FontIcon,  Chip} from "material-ui"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import MessageCenterStore from "../../stores/MessageCenterStore"

interface IProps {
    gigPoolItem: IGigPoolDocument
    onEdit(item: IGigPoolDocument): void
}

const GigPoolItem: React.SFC<IProps> = (props: IProps) => {
    return (
        <div className="Box" style={{width: 400, marginRight: 15, marginBottom: 15}}>
            <div style={{display: "grid", gridTemplateColumns: "auto min-content min-content min-content"}}>
                <div style={{gridColumn: 1}}>
                    <div>
                        <b style={{fontSize: 14}}>{props.gigPoolItem.Name}</b>
                    </div>
                    <div>
                        {props.gigPoolItem.EmployeeCount} {strings.Gig_Pool_Members} <i className="fa-solid fa-circle-info" style={{cursor: "pointer", color: "#999999"}} />
                    </div>
                    <div style={{display: "flex", flexWrap: "wrap", gap: 2, marginTop: 5, marginBottom: 3}}>
                        {props.gigPoolItem.Core && <Chip labelStyle={{fontSize: 12}}>Core</Chip>}
                        {props.gigPoolItem.Float && <Chip labelStyle={{fontSize: 12}} >Float</Chip>}
                        {props.gigPoolItem.PerDiem && <Chip labelStyle={{fontSize: 12}} >Per Diem</Chip>}
                        {props.gigPoolItem.Agency && <Chip labelStyle={{fontSize: 12}} >Agency</Chip>}
                    </div>
                    <div style={{display: "flex", flexWrap: "wrap", gap: 2, marginTop: 5, marginBottom: 3}}>
                    {props.gigPoolItem.EmployeeStatusList.map((item, key)=> 
                        <Chip labelStyle={{fontSize: 12}} key={key}>{item.Name}{item.EmployeeSubStatus && <span>: {item.EmployeeSubStatus.Name}</span>}</Chip>
                    )}
                    </div>
                </div>
                <div style={{gridColumn: 2, paddingRight: 10}}>
                    <FontIcon className="fa fa-messages" onTouchTap={() => {
                        MessageCenterStore.setGigPoolId(props.gigPoolItem.Id)
                        MessageCenterStore.setSubTitle(props.gigPoolItem.Name + " " + strings.Gig_Pool)
                        MessageCenterStore.setGroupName("User Message")
                        MessageCenterStore.setContextDescription("GigPool " + props.gigPoolItem.Name + " AdHoc Message")
                        MessageCenterStore.setObjectId(props.gigPoolItem.Id)
                        AppStateStore.openMessageCenterDrawer()
                    }} style={{cursor: "pointer", fontSize: 16}}/>
                </div>                     
                <div style={{gridColumn: 3, paddingRight: 10}}>
                    <FontIcon className="fa fa-edit" onTouchTap={() => {props.onEdit(props.gigPoolItem)}} style={{cursor: "pointer", fontSize: 16}}/>
                </div>
                <div style={{gridColumn: 4 }}>
                    <FontIcon className="fa fa-trash" onTouchTap={() => {props.onEdit(props.gigPoolItem)}} style={{cursor: "pointer", fontSize: 16}}/>
                </div>                                       
            </div>
            <div style={{borderTop: "2px solid #efefef", marginTop: 5, paddingTop: 10}} >
                2344 Messages Sent <i className="fa-solid fa-circle-info" style={{cursor: "pointer", color: "#999999"}} />
            </div>
            <div>
                34 Pending Shifts  <i className="fa-solid fa-circle-info" style={{cursor: "pointer", color: "#999999"}} />                    
            </div>                 
        </div>
    )
}

export default GigPoolItem